import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from "react";
import { FloatingCommentForm } from "~/components/Annotations/shared/FloatingCommentForm";
import { BoundingBoxTextContainer } from "~/components/BoundingBox/components/BoundingBoxTextContainer";
import { useAccountContext } from "~/providers/AccountProvider";
export const AnnotationCommentInput = /*#__PURE__*/ memo((props)=>{
    const { data } = useAccountContext();
    return /*#__PURE__*/ _jsx(BoundingBoxTextContainer, {
        user: data,
        ...props,
        children: /*#__PURE__*/ _jsx(FloatingCommentForm, {})
    });
});
AnnotationCommentInput.displayName = "BoxAnnotationCommentInput";
